import React from 'react';
import { Row, Col } from 'antd';
import {
    ArrowRightOutlined
  } from '@ant-design/icons';


function SearchProperties(props) {
    return (
        <Row>
            <Col xs={1} xl={4}>

            </Col>
            <Col xs={22} xl={16}>
                <h1>Search Field List</h1>
                
                <p>This section documents the common fields availible through the search API. This is by no means a complete list and you should contact your client manager if you have specific requests.</p>
                <div className="sectionlist">
                <ul>
                    <li>title <ArrowRightOutlined /> This title of the document</li>
                    <li>product_types <ArrowRightOutlined /> Product types associated with the document for instance "Sabinet African Journals - All Journals"</li>
                    <li>search_keywords <ArrowRightOutlined /> This field contains a copy of several of the key metadata fields including the fulltext. it is good to use for general search.</li>
                    <li>ocr_text <ArrowRightOutlined /> The extracted text of pdf documents</li>
                    <li>original_publication_date <ArrowRightOutlined /> A key date for the document, normally the publication date</li>
                </ul>
                </div>

                <p>When performing an exact match you can use the .keyword subfield for each of these as this stores the original raw version</p>

<p>For instance to search for a specific product type within a publication date range the query would look like</p>

<pre><code>curl -X POST "https://api.sabinet-arq.com/search/resourcespublic" -H "Content-Type: application/json" -d '&#123;"query":&#123;"bool":&#123;"must":[&#123;"bool":&#123;"must":[&#123;"term":&#123;"product_types.keyword":"Legal - Government Gazettes"&#125;&#125;]&#125;&#125;,&#123;"range":&#123;"original_publication_date":&#123;"gte":"2022-06-01","lte":"2022-06-29"&#125;&#125;&#125;]&#125;&#125;,"size":10,"from":0,"_source":&#123;"includes":["*"],"excludes":[]&#125;,"sort":[&#123;"original_publication_date":&#123;"order":"desc"&#125;&#125;]&#125;' -H "Authorization: IDTOKEN "</code></pre>

<p>To gain the list of possibile values for list field such as product types you can run an aggregation query. For example</p>

<pre><code>curl -X POST "https://api.sabinet-arq.com/search/resourcespublic" -H "Content-Type: application/json" -d '&#123;
  "size":0,
  "_source":&#123;
    "includes":[
      "*"
    ],
    "excludes":[
      
    ]
  &#125;,
  "aggs":&#123;
    "product_types":&#123;
      "terms":&#123;
        "field":"product_types.keyword",
        "size":1000,
        "order":&#123;
          "_count":"desc"
        &#125;
      &#125;
    &#125;
  &#125;
&#125;
  ' -H "Authorization: IDTOKEN "</code></pre>

<p>This will return the complete list of product types and the count of documents indexed for them</p>

          </Col>
            <Col xs={1} xl={4}>

            </Col>
        </Row>
    )
}
export default SearchProperties;